// Copyright (c) 2017 PlanGrid, Inc.

import React, { Component } from 'react';

import '../../styles/video.css';
import Loading from '../loading';
//import ReactJWPlayer from 'react-jw-player';
import "video-react/dist/video-react.css";
import { Player } from 'video-react';

class VideoViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  onCanPlay() {
    this.setState({ loading: false });
  }

  renderLoading() {
    if (this.state.loading) {
      return <Loading />;
    }
    return null;
  }

  render() {
    const visibility = this.state.loading ? 'hidden' : 'visible';
    return (
      <div className="pg-driver-view">
        {/* <div className="video-container"> */}
        {/* {this.renderLoading()} */}
        <Player
          playsInline
          poster=""
          fluid={false}
          width="100%"
          height="100%"
          src={this.props.filePath}
        />
        {/* <ReactJWPlayer
            playerId='my-unique-id'
            customProps={{ width: '100%', height: 422 }}
            playerScript='https://content.jwplatform.com/libraries/74JgZciX.js'
            file={this.props.filePath}
            type="mp4"
          /> */}
        {/* <video
            style={{ visibility }}
            controls
            type={`video/${this.props.fileType}`}
            onCanPlay={e => this.onCanPlay(e)}
            src={this.props.filePath}
          >
            Video playback is not supported by your browser.
          </video> */}
        {/* </div> */}
      </div>
    );
  }
}

export default VideoViewer;
